[
  {
    "dia": "14M",
    "mupi": 1,
    "hora": "10h25min",
    "numero": 1,
    "titulo": "Energy Drinks and Pre-Workout Supplements: An Analysis of pH Levels Through an In Vitro Study",
    "autor": "Laura Marqués Martínez"
  },
  {
    "dia": "14M",
    "mupi": 1,
    "hora": "10h32min",
    "numero": 2,
    "titulo": "Caracterização óptica e efeito antimicrobiano do Pelargonium sidoides associado à luz na endodontia",
    "autor": "Sâmmea Martins Vieira"
  },
  {
    "dia": "14M",
    "mupi": 1,
    "hora": "10h39min",
    "numero": 3,
    "titulo": "Avaliação da biocompatibilidade de cimentos endodônticos",
    "autor": "Patricia Ribeiro"
  },
  {
    "dia": "14M",
    "mupi": 1,
    "hora": "10h46min",
    "numero": 4,
    "titulo": "Desenvolvimento de sistema experimental de impacto para avaliação do desempenho de protetores bucais",
    "autor": "Diana Angélica Fernandes"
  },
  {
    "dia": "14M",
    "mupi": 2,
    "hora": "10h25min",
    "numero": 5,
    "titulo": "Tradução e Adaptação cultural do questionário “Oral Cancer Pain Questionnaire” – UCSF",
    "autor": "Cristiana Rodrigues"
  },
  {
    "dia": "14M",
    "mupi": 2,
    "hora": "10h32min",
    "numero": 6,
    "titulo": "Avaliação do Biomarcador Salivar Cortisol em Doentes com Disfunção Temporomandibular",
    "autor": "Carla Cardoso"
  },
  {
    "dia": "14M",
    "mupi": 2,
    "hora": "10h39min",
    "numero": 7,
    "titulo": "Eficácia da Acupuntura em casos de Disfunção Temporomandibular Crónica: protocolo de estudo piloto",
    "autor": "Mariana Frade"
  },
  {
    "dia": "14M",
    "mupi": 2,
    "hora": "10h46min",
    "numero": 8,
    "titulo": "O impacto dos autocuidados em ambulatório na Disfunção Temporomandibular – Protocolo clínico",
    "autor": "Beatriz O. Castro"
  },
  {
    "dia": "14M",
    "mupi": 2,
    "hora": "10h53min",
    "numero": 40,
    "titulo": "Avaliação do Conhecimento e Consciencialização dos Estudantes de Medicina Dentária sobre a Prescrição de Antibióticos em Endodontia",
    "autor": "Francisco Faria"
  },
  {
    "dia": "14M",
    "mupi": 3,
    "hora": "10h25min",
    "numero": 9,
    "titulo": "Ortopedia Pré-Cirúrgica na Fenda Lábio-Palatina: Casos Clínicos",
    "autor": "Catarina Machado"
  },
  {
    "dia": "14M",
    "mupi": 3,
    "hora": "10h32min",
    "numero": 10,
    "titulo": "Tratamento ortodôntico de tração do canino maxilar incluso: Caso Clínico",
    "autor": "Daniela Basto"
  },
  {
    "dia": "14M",
    "mupi": 3,
    "hora": "10h39min",
    "numero": 11,
    "titulo": "Granuloma piogénico: revisão da literatura a propósito de um caso clínico",
    "autor": "Joana Barbosa Magalhães"
  },
  {
    "dia": "14M",
    "mupi": 3,
    "hora": "10h46min",
    "numero": 12,
    "titulo": "Avulsão dentária em jovem: do diagnóstico ao prognóstico",
    "autor": "Andreia Esteves Fernandes"
  },
  {
    "dia": "14M",
    "mupi": 3,
    "hora": "10h53min",
    "numero": 39,
    "titulo": "From Revitalization to Apexification: A 14-year journey of an immature permanent tooth",
    "autor": "Beatriz P. Santos"
  },
  {
    "dia": "14T",
    "mupi": 1,
    "hora": "15h45min",
    "numero": 13,
    "titulo": "Rânula: Do Diagnóstico à Abordagem Cirúrgica – Caso Clínico",
    "autor": "João Gustavo Lourenço"
  },
  {
    "dia": "14T",
    "mupi": 1,
    "hora": "15h52min",
    "numero": 14,
    "titulo": "White Oral Lesions: a report of three cases with distinct clinical diagnoses",
    "autor": "Mariana Trigo"
  },
  {
    "dia": "14T",
    "mupi": 1,
    "hora": "15h59min",
    "numero": 15,
    "titulo": "Lipoma no pavimento oral, um diagnóstico imprevisto",
    "autor": "Carlos Salgado"
  },
  {
    "dia": "14T",
    "mupi": 2,
    "hora": "15h45min",
    "numero": 16,
    "titulo": "Toxina Botulínica no Controlo da Dor Miofascial Refratária: Caso Clínico",
    "autor": "Carolina Ferreira"
  },
  {
    "dia": "14T",
    "mupi": 2,
    "hora": "15h52min",
    "numero": 17,
    "titulo": "Materiais e técnica para confeção de chave de reposicionamento na colagem de fragmentos coronários",
    "autor": "Francisco Carneiro"
  },
  {
    "dia": "14T",
    "mupi": 2,
    "hora": "15h59min",
    "numero": 18,
    "titulo": "Abnormal Tooth Wear Associated with Tongue Piercings",
    "autor": "Diana Ramos"
  },
  {
    "dia": "14T",
    "mupi": 3,
    "hora": "15h45min",
    "numero": 19,
    "titulo": "Literacia parental sobre anquiloglossia e implicações no desenvolvimento infantil – state of art",
    "autor": "Beatriz Martins"
  },
  {
    "dia": "14T",
    "mupi": 3,
    "hora": "15h52min",
    "numero": 20,
    "titulo": "Os primeiros 1000 dias e a saúde oral: Um período decisivo para a prevenção",
    "autor": "Beatriz Carneiro"
  },
  {
    "dia": "14T",
    "mupi": 3,
    "hora": "15h59min",
    "numero": 21,
    "titulo": "Suplementos coadjuvantes do sono em idade pediátrica e saúde oral: revisão narrativa da literatura",
    "autor": "Anita Rodrigues"
  },
  {
    "dia": "14T",
    "mupi": 3,
    "hora": "16h06min",
    "numero": 22,
    "titulo": "Leite de fórmula e implicações na saúde oral do bebé: revisão narrativa da literatura",
    "autor": "Emilia Pereira"
  },
  {
    "dia": "14T",
    "mupi": 3,
    "hora": "16h12min",
    "numero": 35,
    "titulo": "A importância da Terapia da Fala associada à Ortodontia",
    "autor": "Mariana Pascoal"
  },
  {
    "dia": 15,
    "mupi": 1,
    "hora": "10h45min",
    "numero": 23,
    "titulo": "Influência da escola nas escolhas alimentares das crianças e dos pais - revisão narrativa",
    "autor": "Raquel Cavaco"
  },
  {
    "dia": 15,
    "mupi": 1,
    "hora": "10h52min",
    "numero": 24,
    "titulo": "Manifestações orais em crianças com patologia cardíaca congénita: Revisão Narrativa",
    "autor": "Matilde Veiga"
  },
  {
    "dia": 15,
    "mupi": 1,
    "hora": "10h59min",
    "numero": 25,
    "titulo": "Impact of Sodium Hypochlorite on the Chemical Composition of Coronal Dentin: A Literature Review",
    "autor": "Bianca Gomes"
  },
  {
    "dia": 15,
    "mupi": 1,
    "hora": "11h06min",
    "numero": 26,
    "titulo": "Alterações do microbioma oral na obesidade",
    "autor": "Joana Melo"
  },
  {
    "dia": 15,
    "mupi": 1,
    "hora": "11h13min",
    "numero": 27,
    "titulo": "Relação entre alterações salivares e a Síndrome Metabólica",
    "autor": "Juliana Soares"
  },
  {
    "dia": 15,
    "mupi": 2,
    "hora": "10h45min",
    "numero": 28,
    "titulo": "Caracterização de sistemas de matrizes para a realização de restaurações Classe II",
    "autor": "Beatriz Pimparel"
  },
  {
    "dia": 15,
    "mupi": 2,
    "hora": "10h52min",
    "numero": 29,
    "titulo": "Ativação dos sistemas de Irrigação em Endodontia: revisão narrativa",
    "autor": "Mariana Cunha"
  },
  {
    "dia": 15,
    "mupi": 2,
    "hora": "10h59min",
    "numero": 30,
    "titulo": "Cimentos Biocerâmicos: Invovação no Tratamento Endodôntico e Promoção da Regeneração Pulpar",
    "autor": "Carlota Ávila"
  },
  {
    "dia": 15,
    "mupi": 2,
    "hora": "11h06min",
    "numero": 31,
    "titulo": "Nanotecnologia em Endodontia: O Papel das Nanopartículas no Tratamento Endodôntico",
    "autor": "Djeinifa Spencer"
  },
  {
    "dia": 15,
    "mupi": 2,
    "hora": "11h13min",
    "numero": 32,
    "titulo": "Avaliação dos Cimentos de Obturação - Revisão Narrativa",
    "autor": "Tiago Nóbrega"
  },
  {
    "dia": 15,
    "mupi": 3,
    "hora": "10h45min",
    "numero": 33,
    "titulo": "Ortopedia dentofacial no tratamento da Síndrome Obstrutiva da Apneia do Sono Pediátrica: state of art",
    "autor": "Óscar Gonçalves"
  },
  {
    "dia": 15,
    "mupi": 3,
    "hora": "10h52min",
    "numero": 34,
    "titulo": "ESTÉTICA DO SORRISO: REVISÃO NARRATIVA",
    "autor": "Bárbara Vieira"
  },
  {
    "dia": 15,
    "mupi": 3,
    "hora": "10h59min",
    "numero": 38,
    "titulo": "Extracellular Vesicles for Endodontic Applications: New Clinical and Research Approaches",
    "autor": "Teresa Santos"
  },
  {
    "dia": 15,
    "mupi": 3,
    "hora": "11h06min",
    "numero": 36,
    "titulo": "USO DE APÓSITOS INTRA-ALVEOLARES APÓS UMA EXTRAÇÃO DENTÁRIA: REVISÃO NARRATIVA",
    "autor": "Maria Dias"
  },
  {
    "dia": 15,
    "mupi": 3,
    "hora": "11h13min",
    "numero": 37,
    "titulo": "Impacto dos Inibidores Seletivos da Recaptação de Serotonina na Cirurgia Oral",
    "autor": "Sofia Correia"
  }
]